import { remove } from '../index';

export const removeUserFromBrand = data => {
  return remove('/brands/share', data);
};
